<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VTM5X2/tc-custom/9781429943338.jpg?1737776588318" alt="This image is the cover for the book Graveland"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Graveland
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Someone is assassinating the financial industry's most powerful players—in cold blood and in broad daylight—in intricate, eerily relevant new thriller from Alan Glynn, the award-winning author of <i>Bloodland</i> and <i>Limitless</i>. <br/><br/></b>On a bright Saturday morning, a Wall Street investment banker is shot dead while jogging in Central Park. Hours later, one of New York City's savviest hedge-fund managers is gunned down outside a restaurant. Are these killings a coordinated terrorist attack, or just a coincidence? Investigative journalist Ellen Dorsey has a hunch they're neither, and when an attempt is made on the life of another CEO, her theory is confirmed. The story blows wide open, and as Ellen races to stay ahead of the curve, her path collides with that of a recession-hit architect, Frank Bishop, whose daughter's disappearance may be tied to the murders.<br/><br/>Set deep in a shadow world of corrupt business deals and radical politics—with a plot that echoes today's headlines in haunting and unexpected ways—<i>Graveland</i> is a mind-blowing thriller that intensifies with every page.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alan Glynn
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Picador
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4196e09a